import { Segment } from 'shared/segments-navigation/segment.interface';

export const accountInfoSegments: Array<Segment> = [
  {
    id: 'profile',
    title: 'Profile',
    active: true,
  },
  {
    id: 'team',
    title: 'Team',
    active: false,
    // allow to  all except 'repository'
    allow: ['catalog-view', 'catalog-edit', 'dam-view', 'dam-edit', 'fitments', 'admin'],
  },
  {
    id: 'preferences',
    title: 'Preferences',
    active: false,
  },
  {
    id: 'brand-info',
    title: 'Brand',
    circleIcon: true,
    active: true,
    allow: ['admin'],
  },
  {
    id: 'trade-info',
    title: 'Trade Info',
    circleIcon: false,
    active: false,
    allow: ['admin'],
  },
  {
    id: 'billing',
    title: 'Billing',
    active: false,
    allow: ['admin', 'repository'],
  },
];
